module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-copyright"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "my-4"
  }, [_vm._v("All site content, except where otherwise notes, is licensed under a Creative Commons Attribution 3.0 License.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "my-4"
  }, [_vm._v("Copyright © 2008-2016 Impact Journals, LLC. All rights reserved. Impact Journals is a trademark of Impact Journals, LLC.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1240b618"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main-layout/footer-area/copyright/FooterCopyrightComponent.vue
// module id = 1391
// module chunks = 1